import NoteBox from "../../../../../design-system/src/components/NoteBox/NoteBox";
import NoteBoxQuotation from "../../../../../design-system/src/components/NoteBox/NoteBoxQuotation";
import { QuotationMarkIcon } from "../../../../../design-system/src/components/Icons";
import * as React from 'react';
export default {
  NoteBox,
  NoteBoxQuotation,
  QuotationMarkIcon,
  React
};